import React from 'react';
import PropTypes from 'prop-types';
import { TARGET_FIELDS_PROP_TYPE } from 'shared/constants/PropTypes';
import TTSelectField from '../../../ttSelectField/TTSelectField';
import TTSourceColumns from '../ttSourceColumn/TTSourceColumn';

class TTTargetColumns extends React.Component {
  constructor (props){
    super(props);
    this.state = { selectedValue: props.value || '' };
  }

  handleSelectChange = (event, key, currentValue) => {
    this.setState({ selectedValue: currentValue});
    this.props.onValueChange(this.props.targetColumnId, currentValue);
  };

  render() {
    const { targetFields, disabled } = this.props;
    return (
      <div>
        <TTSelectField
          defaultLabel={ 'Sovos System Columns' }
          items={ targetFields }
          value={ this.state.selectedValue }
          onValueChange={ this.handleSelectChange }
          disabled={ disabled }
        />
      </div>
    );
  }
}

TTTargetColumns.propTypes = {
  targetColumnId: PropTypes.number.isRequired,
  targetFields: TARGET_FIELDS_PROP_TYPE.isRequired,
  onValueChange: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool
};

TTSourceColumns.defaultProps = {
  onValueChange: () => null,
  disabled: false
};

export default TTTargetColumns;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttColumnManager/c/ttTargetColumn/TTTargetColumn.js